import { render, staticRenderFns } from "./LatestEntriesCardEmpty.vue?vue&type=template&id=49a5d493"
import script from "./LatestEntriesCardEmpty.vue?vue&type=script&lang=ts"
export * from "./LatestEntriesCardEmpty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports